import { Component, ElementRef, inject, Input, QueryList, ViewChildren } from '@angular/core';
import { FrontendFieldDefinition } from '../../models/frontend-field-definition.model';
import { FrontendFormDefinition } from '../../models/frontend-form-definition.model';
import { SmFormFieldComponent } from '../sm-form-field/sm-form-field.component';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'sm-form',
    templateUrl: './sm-form.component.html',
    styleUrls: ['./sm-form.component.scss']
})
export class SmFormComponent {

    elementRef = inject(ElementRef)

    _form: FrontendFormDefinition = null;
    _fields: FrontendFieldDefinition[][] = [];

    @Input()
    fixedWidth: number = null;

    @Input()
    fixedHeight: number = null;
    
    @ViewChildren('fields') fields: QueryList<SmFormFieldComponent>;

    @Input()
    set form(value: FrontendFormDefinition) {
        this._form = value;
        this._fields = value != null ? value.getGroupedFields() : [];
    }

    focus(fieldId?: string): void {
        if (Utils.isNoe(fieldId)) {
            if (this.fields.length > 0) {
                this.fields.first.focus();
            }
        }
        else {
            const nativeElement = this.elementRef.nativeElement as HTMLElement;
            const fieldElement = nativeElement.querySelector(`[data-id="${fieldId}"]`);
            if (fieldElement) {
                (fieldElement as any).focus();
            } else {
                console.warn(`Field with ID ${fieldId} not found.`);
            }
        }
    }
    
    thisComponentAsTableEditorInited(): void {
        if (this.fields.length > 0) {
            this.fields.first.thisComponentAsTableEditorInited();
        }
    }

}
